import type { ICellRendererParams } from 'ag-grid-community';
import { get } from 'lodash-es';

import { ProductTypeEnum } from '@src/types/types';

export function resolveBlotterAssetIsCurrency(
  params: Pick<ICellRendererParams, 'data' | 'context' | 'value'>,
  assetTypeField?: string
): boolean {
  if (assetTypeField && params.data) {
    return get(params.data, assetTypeField) === ProductTypeEnum.Spot;
  }

  return params.context?.current?.currenciesBySymbol?.has(params.value) ?? false;
}
